import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  Box,
  Divider,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Collapse,
} from "@mui/material";

import ScheduleIcon from "@mui/icons-material/Schedule";
import { Menu, Close, LocationOn, Home, MenuBook, ContactPhone, ExpandLess, ExpandMore } from "@mui/icons-material";

// assets
import pmdriveInLogo from "../../assets/pmdrivein.PNG";

export default function TopBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [expandHours, setExpandHours] = useState(false);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const toggleHours = () => {
    setExpandHours(!expandHours);
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  // Get current day (0-6 where 0 is Sunday)
  const today = new Date().getDay();
  const days = [
    { day: "Sunday", hours: "12:00 PM - 11:00 PM" },
    { day: "Monday", hours: "12:00 PM - 11:00 PM" },
    { day: "Tuesday", hours: "12:00 PM - 11:00 PM" },
    { day: "Wednesday", hours: "12:00 PM - 11:00 PM" },
    { day: "Thursday", hours: "12:00 PM - 11:00 PM" },
    { day: "Friday", hours: "12:00 PM - 11:00 PM" },
    { day: "Saturday", hours: "12:00 PM - 11:00 PM" },
  ];

  return (
    <>
      {/* Top Bar */}
      <AppBar position="static" elevation={0} sx={{ backgroundColor: "white", color: "black" }}>
        <Toolbar
          variant="dense"
          sx={{
            justifyContent: "space-between",
            px: { xs: 1.5, sm: 2 },
            height: "70px",
          }}
        >
          {/* Logo & Title */}
          <Box
            onClick={handleLogoClick}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
            }}
          >
            <Box
              component="img"
              src={pmdriveInLogo}
              alt="Logo"
              sx={{
                height: 60,
                width: 60,
                borderRadius: "4px",
                objectFit: "cover",
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontSize: isMobile ? "15px" : "16px",
                fontWeight: 600,
              }}
              component="div"
            >
              PM DRIVE-IN
            </Typography>
          </Box>

          {/* Hamburger */}
          <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <Menu />
          </IconButton>
        </Toolbar>

        <Divider sx={{ backgroundColor: "#e5e5e5" }} />
      </AppBar>

      {/* Right Drawer */}
      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: 280,
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          {/* Drawer Header with Close Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                component="img"
                src={pmdriveInLogo}
                alt="Logo"
                sx={{
                  height: 34,
                  width: 34,
                  borderRadius: "4px",
                  objectFit: "cover",
                }}
              />
              <Typography variant="h6">PM DRIVE-IN</Typography>
            </Box>
            <IconButton onClick={toggleDrawer(false)}>
              <Close />
            </IconButton>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Address Section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 2,
              backgroundColor: "#f5f5f5",
              borderRadius: 1,
              mb: 2,
            }}
          >
            <LocationOn color="primary" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <Typography variant="body2">Housingboard .RTC colony Near collector office</Typography>
              <Typography variant="body2">Medak, Telangana, 502110</Typography>
            </Box>
          </Box>

          {/* Opening Hours Section */}
          <List>
            <ListItemButton onClick={toggleHours}>
              <ListItemIcon>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText primary="Opening Hours" />
              {expandHours ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={expandHours} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {days.map((day, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      pl: 4,
                      backgroundColor: index === today ? "#e3f2fd" : "transparent",
                    }}
                  >
                    <ListItemText
                      primary={`${day.day}:`}
                      secondary={day.hours}
                      primaryTypographyProps={{
                        fontWeight: index === today ? "bold" : "normal",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </List>
        </Box>
      </Drawer>
    </>
  );
}
